<template>
  <div
    :data-testid="`draggable-remark-${remark.id}`"
    class="tw-flex tw-flex-row tw-w-full tw-pe-8 tw-group"
    :class="backgroundClass"
  >
    <div class="tw-w-8 tw-flex tw-justify-center tw-items-center tw-text-base">
      <span
        data-testid="draggable-remark-handle"
        class="
          handle
          active:tw-cursor-grabbing
          tw-invisible
          tw-cursor-grab
          tw-grid
          tw-grid-cols-2
          tw-grid-rows-4
          tw-gap-0.5
          tw-p-0.5
        "
        :class="handleClasses"
      >
        <i
          v-for="i in 8"
          :key="i"
          class="tw-w-[3px] tw-h-[3px] tw-rounded-full tw-bg-sf-neutral-dark-1"
        />
      </span>
    </div>
    <div class="tw-grow">
      <RemarkV2
        :remark="remark"
        part-of="meeting_preparation"
        show-context
        show-context-btn
        show-period
        hide-read-status
        show-tags
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'
import { Remark } from '@app/application/communication/types'

interface Props {
  remark: Remark
  handleClass: string
  dragging: boolean
}

const props = defineProps<Props>()

const backgroundClass = computed(() => {
  if (props.dragging) {
    return []
  } else {
    return ['hover:tw-bg-sf-neutral-subtle-2', 'active:tw-bg-transparent']
  }
})

const handleClasses = computed(() => {
  if (props.dragging) {
    return []
  } else {
    return ['group-hover:tw-visible']
  }
})
</script>

<style scoped lang="scss">
[draggable='true'] {
  opacity: 0.5;
}
</style>
